function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var ControlsTemplate = require('./controls.template');
var SaitoOverlay = require('../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var ControlsOverlay = /*#__PURE__*/function () {
  function ControlsOverlay(app) {
    var mod = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    _classCallCheck(this, ControlsOverlay);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.overlay = new SaitoOverlay(app, mod, false);
    this.refresh_timer = null;
  }
  return _createClass(ControlsOverlay, [{
    key: "currentMappings",
    value: function currentMappings() {
      try {
        var _myApp;
        if (typeof myApp !== 'undefined' && (_myApp = myApp) !== null && _myApp !== void 0 && (_myApp = _myApp.rivetsData) !== null && _myApp !== void 0 && (_myApp = _myApp.inputController) !== null && _myApp !== void 0 && _myApp.KeyMappings) {
          return JSON.parse(JSON.stringify(myApp.rivetsData.inputController.KeyMappings));
        }
      } catch (err) {}
      return {};
    }
  }, {
    key: "prepareEmulatorRemap",
    value: function prepareEmulatorRemap() {
      if (typeof myApp === 'undefined' || !myApp.rivetsData) {
        return;
      }
      if (!myApp.rivetsData.inputLoopStarted) {
        myApp.rivetsData.inputLoopStarted = true;
        myApp.rivetsData.inputController.setupGamePad();
        setTimeout(function () {
          if (typeof myClass !== 'undefined') {
            myClass.inputLoop();
          }
        }, 100);
      }
      if (myApp.rivetsData.inputController.Gamepad_Process_Axis) {
        myApp.rivetsData.chkUseJoypad = true;
      }
      myApp.rivetsData.remappings = JSON.parse(JSON.stringify(myApp.rivetsData.inputController.KeyMappings));
      myApp.rivetsData.remapWait = false;
    }
  }, {
    key: "render",
    value: function render() {
      this.prepareEmulatorRemap();
      this.overlay.show(ControlsTemplate(this.app, this.mod, this.currentMappings()));
      this.attachEvents();
      this.startRefreshLoop();
    }
  }, {
    key: "refreshBindings",
    value: function refreshBindings() {
      var _myApp$rivetsData;
      var root = document.querySelector('.nwasm-controls');
      if (!root || typeof myApp === 'undefined') {
        return;
      }
      var maps = ((_myApp$rivetsData = myApp.rivetsData) === null || _myApp$rivetsData === void 0 ? void 0 : _myApp$rivetsData.remappings) || this.currentMappings();
      root.querySelectorAll('.binding[data-map]').forEach(function (el) {
        var key = el.getAttribute('data-map');
        if (!key) {
          return;
        }
        el.textContent = maps[key] || '';
      });
      var wait = root.querySelector('.wait');
      if (wait) {
        var _myApp$rivetsData2;
        wait.hidden = !((_myApp$rivetsData2 = myApp.rivetsData) !== null && _myApp$rivetsData2 !== void 0 && _myApp$rivetsData2.remapWait);
      }
    }
  }, {
    key: "startRefreshLoop",
    value: function startRefreshLoop() {
      var _this = this;
      this.stopRefreshLoop();
      this.refresh_timer = setInterval(function () {
        _this.refreshBindings();
      }, 200);
    }
  }, {
    key: "stopRefreshLoop",
    value: function stopRefreshLoop() {
      if (this.refresh_timer) {
        clearInterval(this.refresh_timer);
        this.refresh_timer = null;
      }
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this2 = this;
      var root = document.querySelector('.nwasm-controls');
      if (!root) {
        return;
      }
      root.onclick = function (e) {
        var btn = e.target.closest('[data-action]');
        if (!btn || typeof myApp === 'undefined') {
          return;
        }
        var action = btn.getAttribute('data-action');
        var id = parseInt(btn.getAttribute('data-id') || '0');
        if (action === 'remap-key') {
          myApp.btnRemapKey(id);
          _this2.refreshBindings();
          return;
        }
        if (action === 'remap-joy') {
          myApp.btnRemapJoy(id);
          _this2.refreshBindings();
          return;
        }
        if (action === 'defaults') {
          myApp.restoreDefaultKeymappings();
          _this2.refreshBindings();
          return;
        }
        if (action === 'save') {
          // Avoid bootstrap modal hide; persist mappings directly.
          if (myApp.rivetsData.chkUseJoypad) {
            myApp.rivetsData.inputController.Gamepad_Process_Axis = true;
          } else {
            myApp.rivetsData.inputController.Gamepad_Process_Axis = false;
          }
          myApp.rivetsData.inputController.KeyMappings = JSON.parse(JSON.stringify(myApp.rivetsData.remappings));
          myApp.rivetsData.inputController.setGamePadButtons();
          localStorage.setItem('n64wasm_mappings_v3', JSON.stringify(myApp.rivetsData.remappings));
          _this2.stopRefreshLoop();
          _this2.overlay.hide();
        }
      };
    }
  }]);
}();
module.exports = ControlsOverlay;